import React from 'react';
import './error.scss';
import nerdi_error from '../../../assets/Nerdi.gif';

const Error = () => {
    return (
        <div className='error'>
            <img src={nerdi_error} width={300} alt="nerdy error ah ah ah"/>    
        </div>
    );
}

export default Error;